<template>
    <van-cell-group>

        <van-cell>
            <span  slot="title" class="wcc-icon wcc-icon-close1" @click="$emit('close')"
                   style="font-size:16px; color:#43b292; padding: 0 10px;line-height: 18px;height: 18px"
            > </span>

            <span  slot="right-icon" class="wcc-icon wcc-icon-addpost" @click="saveEdit"
                   style="margin-right:5px;font-size:11px;border-radius: 999px;color:#43b292;border: 1px solid #43b292;padding: 0 10px;line-height: 18px;height: 18px"
            > 保存</span>

<!--            <van-button plain hairline round icon="success" size="small"-->
<!--                         color="#4bb0ff"  @click="saveEdit"> 保存 </van-button> -->
        </van-cell>
        <van-field ref="postContent"
                   v-model="topic.content"
                   rows="5"
                   autosize
                   type="textarea"
                   maxlength="500"
                   placeholder="请输入内容"
                   show-word-limit
        />
        <van-uploader v-model="imgList" result-type="file" style="margin-top:10px"
                      :before-delete="delPic"
                      :after-read="afterRead"
                      :before-read="beforeRead"
                      upload-text="添加图片"
        />
    </van-cell-group>
</template>

<script>
    // @ is an alias to /src
    import {Toast} from "vant"

    export default {
        name: 'editTopic',
        props: ["topic"],
        components: {},
        data: function () {
            return {
                imgList: []
            }
        },
        methods: {
            goBack: function () {
                this.$router.push("/");
            },
            saveEdit: function () {
                var app = this;

                var content = app.topic.content;

                if (!content || content.length < 8) {
                    Toast('填写内容,至少8个字');
                    app.$refs.postContent.focus();
                    return;
                }


                app.imgList.forEach(function (item) {
                    console.log("item", item);
                    content = content.replace('[图片:' + item.file.name + ']', '<img src="' + item.url + '" style="max-width: 200px">')
                });

                app.axios.post("/editTopic", {
                    tid: app.topic.tid,
                    content: content
                }).then(function (res) {
                    console.log("editTopic return", res)
                    if (res.data.errcode == "suc") {
                        app.$emit("editOk");
                        app.imgList=[];
                    } else {

                    }
                })
            },
            afterRead(file, detail) {
                this.imgList.forEach(function (item) {
                    item.url = item.file.url;
                })
                console.log("afterRead", file)
            },
            beforeRead: function (file, detail) {
                var app = this;
                var formData = new FormData();
                var filename = file.name;
                formData.append('file', file, file.name)

                return app.axios.post("/uploadFile", formData, {
                    headers: {'Content-Type': 'multipart/form-data1'}
                }).then(function (res) {
                    if (res.data.errcode == 'suc') {
                        var imgUrl = res.data.data.url;
                        file.url = imgUrl;

                        var textPos = app.$refs.postContent.$refs.input.selectionStart;
                        app.topic.content = app.topic.content.substr(0, textPos) + '[图片:' + filename + ']' + app.topic.content.substr(textPos);

                        return Promise.resolve();
                    } else {
                        return Promise.reject();
                    }
                })


            },
            delPic: function (files, detail) {

                var app = this;
                var tag = '[图片:' + files.file.name + ']';
                console.log("delPic", tag);
                app.topic.content = app.topic.content.replace(tag, '');

                return Promise.resolve();
                // return new Promise(function(resolve,reject){
                //     return resolve();
                // })
            },

        },
        mounted: function () {

        }
    }
</script>
<style>
    .van-uploader__upload-text{
        color:#43b292;
        font-size: 12px;
    }
    .van-uploader__upload-icon{
        color:#43b292;
    }
    .van-icon-plus:before{
        font: 14px/1 "FontAwesome";
        font-size: 18px;
        content: "\f0fe"
    }
</style>
